import React, { useState } from 'react';
import SelectBaseDc from './SelectBaseDc';
import SelectBaseOs from '../shared/imageWizard/SelectBaseOs';
import SelectBaseKind from '../shared/imageWizard/SelectBaseKind';
import SelectBaseImage from '../shared/imageWizard/SelectBaseImage';
import { EXAM_STEPS } from '../shared/imageWizard/StepperSidebar';


function MultipleStepBaseImage(props) {
    const [statusForm, setStatusForm] = useState({
        step: 1,
        datacenter: '',
        os: '',
        kindImage: '',
    });

    const { step } = statusForm;

    const prevStep = () => {
        props.setMultipleBaseStepCompleted(false);
        switch (statusForm.step) {
            case 2:
                setStatusForm({
                    ...statusForm,
                    os: "",
                    step: step - 1,
                });
                break;
            case 3:
                setStatusForm({
                    ...statusForm,
                    kindImage: "",
                    step: step - 1,
                });
                break;
            case 4:
                setStatusForm({
                    ...statusForm,
                    step: step - 1,
                });
                break;
            default:
                break;
        }
    }

    const handleSelectDc = (myDc) => {
        setStatusForm({ ...statusForm, datacenter: myDc, step: step + 1 });
    }

    const handleSelectOs = (myOs) => {
        setStatusForm({ ...statusForm, os: myOs, step: step + 1 });
    }

    const handleSelectKindImage = (myKindImage) => {
        setStatusForm({ ...statusForm, kindImage: myKindImage, step: step + 1 });
    }


    switch (step) {
        case 1:
            return <SelectBaseDc
                handleSelectDc={handleSelectDc}
                statusForm={statusForm}
                setUseStandardCluster={props.setUseStandardCluster}
            />
        case 2:
            return <SelectBaseOs
                prevStep={prevStep}
                handleSelectOs={handleSelectOs}
                statusForm={statusForm}
                currentStep={2}
                stepsConfig={EXAM_STEPS}
            />
        case 3:
            return <SelectBaseKind
                prevStep={prevStep}
                handleSelectKindImage={handleSelectKindImage}
                statusForm={statusForm}
                currentStep={3}
                stepsConfig={EXAM_STEPS}
            />
        case 4:
            return <SelectBaseImage
                prevStep={prevStep}
                setBaseImage={props.setBaseImage}
                baseImage={props.baseImage}
                setIsBookable={props.setIsBookable}
                isBookable={props.isBookable}
                statusForm={statusForm}
                setRepoPkgBundleSelString={props.setRepoPkgBundleSelString}
                setMultipleBaseStepCompleted={props.setMultipleBaseStepCompleted}
                currentStep={4}
                stepsConfig={EXAM_STEPS}
            />
        default:
            return null;
    }
}

export default MultipleStepBaseImage;
